module.exports = __webpack_public_path__ + "img/itemBar_05.5d819641.png";